<script setup lang="ts">
import { onMounted } from 'vue';

onMounted(() => {
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5LFKBJN" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.prepend(noscript);
});
</script>

<template>
  <slot />
</template>
